export default __webpack_public_path__ + "static/media/Bg1.488ac42b.jpg";